import { render, staticRenderFns } from "./Scolaires.vue?vue&type=template&id=61b51551&"
import script from "./Scolaires.vue?vue&type=script&lang=js&"
export * from "./Scolaires.vue?vue&type=script&lang=js&"
import style0 from "./Scolaires.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports